// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppContainer__pnlHome___6WfZP {
    position: relative;
    min-height: 100vh;
    padding-bottom: 70px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pnlHome": `AppContainer__pnlHome___6WfZP`
};
module.exports = ___CSS_LOADER_EXPORT___;
